export default __webpack_public_path__ + "static/25-90b540c1c81e4aabfc8aa57d9ac058d5.png";